import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { awsConfig } from './aws-config';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/common/Toast';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { EntityListPage } from './pages/EntityListPage';
import { EntityDetailPage } from './pages/EntityDetailPage';
import { EntityCreatePage } from './pages/EntityCreatePage';
import { EntityEditPage } from './pages/EntityEditPage';
import { ResetPage } from './pages/ResetPage';
import { CallbackPage } from './pages/CallbackPage';

Amplify.configure(awsConfig);

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <div className="flex items-center justify-center h-screen text-slate-500">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/callback" element={<CallbackPage />} />
            <Route
              path="/"
              element={
                <AuthGuard>
                  <Layout />
                </AuthGuard>
              }
            >
              <Route index element={<Navigate to="/account" replace />} />
              <Route path="admin/reset" element={<ResetPage />} />
              <Route path=":entityName" element={<EntityListPage />} />
              <Route path=":entityName/new" element={<EntityCreatePage />} />
              <Route path=":entityName/:id" element={<EntityDetailPage />} />
              <Route path=":entityName/:id/edit" element={<EntityEditPage />} />
            </Route>
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
